<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'Employees' })"
  >
    <form
      class="modal-card"
      @submit.prevent="update"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Edición de empleado
        </p>
      </header>
      <section class="modal-card-body">
        <Employee
          v-if="loaded"
          :loading="loading"
        />
        <BLoading
          :is-full-page="false"
          :active.sync="loading"
        />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'Employees' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Guardar
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'EditEmployee',

  components: {
    Employee: () => import(/* webpackChunkName: "new-employee" */ '@/components/Admin/Employee/New.vue'),
  },

  data() {
    return {
      loaded: false,
      loading: false,
    };
  },

  async beforeMount() {
    this.loading = true;
    await this.$store.dispatch('employees/getSingle', this.$route.params.employee);
    this.loading = false;
    this.loaded = true;
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit('employees/setValues', {
      name: '',
      email: '',
      rfc: '',
      companyName: '',
    });

    next();
  },

  methods: {
    async update(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('employees/update');
        this.$success({ message: 'El empleado se actualizó exitosamente' });
        this.$router.push({ name: 'Employees' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}
</style>
